'use strict';
// B.2.3.2 String.prototype.anchor(name)
require('./_string-html')('anchor', function(createHTML){
  return function anchor(name){
    return createHTML(this, 'a', 'name', name);
  }
});


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/~/core-js/modules/es6.string.anchor.js
// module id = ../../../../core-js/modules/es6.string.anchor.js
// module chunks = 0